import { logError } from 'utils/log';
import { API, destroy, post, put } from 'utils/api';
import { __t, applyTranslations } from 'utils/language';

import { danger, success } from 'redux-store/reducers/common-reducer';
import { hideLoading, showLoading } from 'redux-store/reducers/loading-reducer';

import {
  DeliverableAttachment,
  DeliverableAttachmentForUpdate,
  LinkedDeliverableAttachment
} from 'types';

applyTranslations(require('./deliverable-insights-reducer.i18n.json'));

export function updateStoryInsightsData(
  offerId: number,
  deliverableId: number,
  addAttachments: Array<DeliverableAttachment>,
  deleteAttachments: Array<number>,
  linkAttachments: Array<LinkedDeliverableAttachment>,
  updateAttachments: Array<DeliverableAttachmentForUpdate>
) {
  return async dispatch => {
    const url = API.END_POINTS.DELIVERABLE.saveInsightsData(offerId, deliverableId);

    dispatch(showLoading(url));

    try {
      const data: {
        addAttachments: Array<DeliverableAttachment>,
        deleteAttachmentsIds: Array<number>,
        linkAttachments: Array<LinkedDeliverableAttachment>,
        updateAttachments: Array<DeliverableAttachmentForUpdate>,
        includesLinkableAssets: boolean
      } = {
        addAttachments,
        linkAttachments,
        updateAttachments,
        deleteAttachmentsIds: deleteAttachments,
        includesLinkableAssets: true
      };

      const deliverableResponse = await put(url, { data });

      dispatch(success(__t('deliverable_insights_reducer.update_success')));

      return {
        ...(deliverableResponse.data || {})
      };
    } catch (error) {
      logError(error);

      if (typeof error === 'string') {
        dispatch(danger(error));
      } else {
        dispatch(danger(__t('deliverable_insights_reducer.update_failed')));
      }

      return null;
    } finally {
      dispatch(hideLoading(url));
    }
  };
}

export function updateInsightsData(
  offerId: number,
  deliverableId: number,
  addAttachments: Array<DeliverableAttachment>,
  deleteAttachments: Array<number>,
  postUrl: string | null,
  isUrlChanged: boolean
) {
  return async (dispatch) => {
    const url = API.END_POINTS.DELIVERABLE.saveInsightsData(offerId, deliverableId);
    const postOfferUrl = API.END_POINTS.DELIVERABLE_MEDIA.updateOfferPost(offerId, deliverableId);

    dispatch(showLoading(url));

    try {
      const data: {
        addAttachments: Array<DeliverableAttachment>,
        deleteAttachmentsIds: Array<number>
      } = {
        addAttachments,
        deleteAttachmentsIds: deleteAttachments
      };

      if (isUrlChanged) {
        try {
          await destroy(postOfferUrl, {}, { suppressGlobalNotification: true });
        } catch {
          throw new Error(__t('deliverable_insights_reducer.post_delete_error'));
        }
      }

      const postUpdateResponse = postUrl && await post(postOfferUrl, {
        data: {
          url: postUrl,
          assetType: 'other'
        } });

      const deliverableResponse = await put(url, {
        data
      });

      dispatch(success(__t('deliverable_insights_reducer.update_success')));

      return {
        ...(deliverableResponse.data || {}),
        post: postUpdateResponse && postUpdateResponse.data
      };
    } catch (error) {
      logError(error);

      if (typeof error === 'string') {
        dispatch(danger(error));
      } else {
        dispatch(danger(__t('deliverable_insights_reducer.update_failed')));
      }

      return null;
    } finally {
      dispatch(hideLoading(url));
    }
  };
}
